import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { ConfigContext } from '../../../contexts/config-context';
import ListingAPI from '../../../axios/listing';
import { AgencyIcon } from '../../main-page/components/featured-listings';
import { formatNumber, LISTING_ROUTES } from '../../main-page/home-utils';
import { listingCover } from '../../search-page/components/result-card';

const MAX_SIMILAR = 4;

export const SimilarListings = ({ listing }) => {
    const { api, searchData, num_rooms_options } = useContext(ConfigContext);
    const { t, i18n } = useTranslation(["details", "home", "listing"]);
    const [similar, setSimilar] = useState([]);
    const lang = i18n.language;

    const typeId = listing.listing_type?.id || 1;
    const search = { ...searchData, listing_type: String(typeId), place: listing.place };

    useEffect(() => {
        let cancelled = false;
        // same city and listing type; one extra in case this listing is among them
        ListingAPI.getListingsSearch(1, search, '-date_created', lang, MAX_SIMILAR + 1)
            .then(res => {
                if (!cancelled) setSimilar(res.data.results.filter(l => l.id !== listing.id).slice(0, MAX_SIMILAR));
            })
            .catch(err => console.log(err));
        return () => { cancelled = true; };
    }, [listing.id, lang]);

    if (similar.length === 0) return null;

    return (
        <section className='hs-similar'>
            <div className='hs-similar-head'>
                <h2>{t('similar_title')}</h2>
                <Link to={LISTING_ROUTES[typeId - 1]} state={{ data: search }} onClick={() => sessionStorage.removeItem('currentPage')}>
                    {t('similar_all', { place: listing.place?.label })} →
                </Link>
            </div>
            <div className='hs-similar-grid'>
                {similar.map(item => {
                    const price = parseFloat(item.price) || 0;
                    const publisher = item.user?.user_type?.label;
                    const rooms = num_rooms_options.find(o => o.id === item.num_rooms)?.label;
                    const meta = [
                        `${formatNumber(item.area)} m²`,
                        rooms && `${rooms} ${t('rooms_short', { ns: 'home' })}`,
                        item.subplace?.label,
                    ].filter(Boolean).join(' · ');
                    return (
                        <Link key={`similar-${item.id}`} to={`/oglas/${item.id}`} className='hs-similar-card'>
                            <div className='hs-similar-photo' style={{ backgroundImage: `url(${listingCover(item, api)})` }}>
                                {/agenc/i.test(publisher || '') && <span className='hs-similar-agency'><AgencyIcon />{publisher}</span>}
                            </div>
                            <div className='hs-similar-body'>
                                <span className='hs-similar-price'>{price > 0 ? `${formatNumber(price)} €` : t('price_placeholder', { ns: 'listing' })}</span>
                                <span className='hs-similar-title'>{item.title}</span>
                                <span className='hs-similar-meta'>{meta}</span>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </section>
    );
};
